<template>
<div class="chapter">
<div class="inner_page">
<a id="p0"></a>
<blockquote class="sink">
<p class="center "><em>For Jason Gamble,</em><br/>
the favorite nephew,</p>
<div class="timebreak "> </div>
<p class="center ">and</p>
<div class="timebreak "> </div>
<p class="center "><em>for Sam’s friend’s daughter . . .</em></p>
<div class="timebreak "> </div>
<p class="center ">both members of the next generation</p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?a6648452